import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';
import { ReactComponent as ArrowHorizontal } from '@pflegia/ui/icons/arrow-horizontal.svg';
import { ReactComponent as ArrowVertical } from '@pflegia/ui/icons/arrow-vertical.svg';
import CardWithTopLine from '@pflegia/ui/shared/card-with-top-line';

import Headline from '../headline/Headline';

export interface SearchFlowProps {
  steps: string[];
}

const SearchFlow: React.FC<SearchFlowProps> = ({ steps }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'searchFlow' });
  const { isPraxia } = useFlavorFromRoute();

  return (
    <section className='container mx-auto'>
      <Headline i18nKey='landingPage:searchFlow.title' />
      <div className='grid gap-4 lg:my-8 lg:grid-cols-4'>
        {steps.map((step, index) => {
          const isReversed = index % 2 !== 0;
          const title = t(`${step}.title${isPraxia ? 'Praxia' : ''}`, { defaultValue: t(`${step}.title`) });

          return (
            <div className='relative grid lg:text-center' key={step}>
              <CardWithTopLine>
                <p className='mb-2 text-4xl font-bold text-main-blue md:text-8xl'>{index + 1}</p>
                <h3 className='mb-2 text-lg font-semibold text-default md:text-2xl'>{title}</h3>
                <h3 className='text-default'>{t(`${step}.description`)}</h3>
              </CardWithTopLine>
              {index < steps.length - 1 && (
                <ArrowVertical
                  className={clsx(
                    'absolute -bottom-5 h-8 w-3 text-main-blue md:h-16 md:w-7 lg:hidden',
                    isReversed ? '-right-4 -scale-x-100' : '-left-4',
                  )}
                />
              )}
              {index < steps.length - 1 && (
                <ArrowHorizontal
                  className={clsx('absolute -right-12 hidden text-main-blue lg:block', isReversed ? '-bottom-9 -scale-y-100' : '-top-9')}
                  height={27}
                  width={69}
                />
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SearchFlow;
